import { Controller } from "@hotwired/stimulus"

// Client-side error toast for capacity-planning mutations. Mounted on the #planning_flash container,
// it listens for the document `planning:flash` event (dispatched by planningMutation when the server
// returns a non-Turbo / failed response, e.g. a 302/403/500 that carries no error stream) and appends
// an auto-dismissing alert that reuses the same markup + `notification` controller as the server-side
// flash partial, so failures are never silent.
export default class extends Controller {
  static values = { defaultMessage: String }

  connect() {
    this.boundFlash = this.flash.bind(this)
    document.addEventListener("planning:flash", this.boundFlash)
  }

  disconnect() {
    document.removeEventListener("planning:flash", this.boundFlash)
  }

  flash(event) {
    const message = event.detail?.message || this.defaultMessageValue
    if (!message) return
    this.element.insertAdjacentHTML("beforeend", this.toastHtml(message))
  }

  toastHtml(message) {
    return `
      <div class="pointer-events-auto w-80 max-w-[90vw] rounded-md border-l-4 border-red-700 bg-red-400 p-4 text-black shadow-lg"
           data-controller="notification" data-notification-dismiss-after-value="6000">
        <div class="flex items-start gap-3">
          <svg class="mt-0.5 h-5 w-5 shrink-0 text-red-800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
          </svg>
          <p class="flex-1 text-sm font-medium leading-snug">${this.escape(message)}</p>
          <button type="button" data-action="notification#dismiss" class="-m-1 shrink-0 rounded p-1 text-red-900 hover:text-black focus:outline-hidden">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>`
  }

  escape(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
